import React, { useMemo, useCallback } from 'react';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { useScheduledBreaks } from './useScheduledBreaks';
import { RevokeScheduledBreak } from '../components/RevokeScheduledBreak';

import style from '../ScheduledBreaks.scss';

export const useTableData = () => {
    const translate = useComponentTranslations();
    const scheduledBreaks = useScheduledBreaks();

    const getAccordionCell = useCallback((item, name) => (
        <>
            <div className="accordionBodyCellName">{translate(name)}</div>
            <div className="accordionBodyCellValue">{item[name]}</div>
        </>
    ), [translate]);

    const getRuleElement = useCallback(({ start, end, timeZone, flags, isRevoked }) => (
        <>
            <span>
                {`${translate('from')} `}
                <span className={style.highlight}>{start}</span>
                {` ${translate('to')} `}
                <span className={style.highlight}>{end}</span>
                <span>{` (${timeZone})`}</span>
            </span>
            {flags === 1 && <span className={style.ruleInfo}>{translate('rule.info')}</span>}
            {isRevoked && <span className={style.ruleInfo}>{translate('rule.revoked')}</span>}
        </>
    ), [translate]);

    return useMemo(() => ({
        tableView: {
            headerCells: [
                { id: 0, content: translate('rules'), className: style.rule },
                { id: 1, content: translate('createDate') },
                { id: 2, content: translate('effectiveEnd') },
                { id: 3, content: translate('revoke'), className: style.action }
            ],
            rows: scheduledBreaks.map(item => {
                const { id, createDate, effectiveEnd, showRevoke } = item;

                return {
                    id,
                    rowCells: [
                        { id: 0, content: getRuleElement(item), className: style.rule },
                        { id: 1, content: createDate },
                        { id: 2, content: effectiveEnd },
                        {
                            id: 3,
                            className: style.action,
                            content: showRevoke ? <RevokeScheduledBreak id={id} /> : null
                        }
                    ]
                };
            })
        },
        accordionView: {
            rows: scheduledBreaks.map(item => {
                const { id, showRevoke, effectiveEnd } = item;
                const rowCells = [
                    { id: 0, content: getAccordionCell(item, 'createDate') }
                ];

                if (effectiveEnd) {
                    rowCells.splice(1, 0, { id: 1, content: getAccordionCell(item, 'effectiveEnd') });
                }

                if (showRevoke) {
                    rowCells.push({
                        id: 2,
                        className: style.accAction,
                        content: <RevokeScheduledBreak id={id} isInAccordion />
                    });
                }

                return {
                    id,
                    rowCells,
                    headerCells: [{
                        id: 0,
                        content: getRuleElement(item),
                        className: 'accordionHeaderSmallDetails'
                    }]
                };
            })
        }
    }), [scheduledBreaks, translate, getRuleElement, getAccordionCell]);
};
